import AnalyticsTracker from './interface';
import func from '../../func';

/**
 * Convenience tracker that does nothing. It's useful because external logic doesn't need to be aware whether a
 * tracker is available or not.
 *
 * @constructor
 * @augments AnalyticsTracker
 */
export default function DummyTracker(window, config) {
    AnalyticsTracker.call(this, window, config);

    /**
     * Does nothing except calling the callback.
     *
     * @param {string} query The user's query as a URL query string.
     * @param {string} filter The last selected filter as a URL query string.
     * @param {function} [callback] Called once the request has been tracked, tracking failed, or timed out.
     *      It can be assumed that this function is called always. No arguments are passed.
     */
    this.trackSearch = function (query, filter, callback) {
        callback = func.undefinedToNoOp(callback);
        callback();
    };

    /**
     * Does nothing except calling the callback.
     *
     * @param {string} event The type of event, usually something like "findologicEvent".
     * @param {string} category Thee event category, e.g. "FINDOLOGIC Click".
     * @param {string} action The user interaction that caused this event, e.g. "Search-Concept".
     * @param {string} label The specific thing the user interacted with.
     * @param {function} [callback] Called once the request has been tracked, tracking failed, or timed out.
     *      It can be assumed that this function is called always. No arguments are passed.
     */
    this.trackEvent = function (event, category, action, label, callback) {
        callback = func.undefinedToNoOp(callback);
        callback();
    };

    /**
     * Determines whether the prerequisites for using this tracker implementation are cleared
     * @returns {boolean}
     */
    this.isAvailable = function () {
        return true;
    };
}
